import { render, staticRenderFns } from "./Reservesub.vue?vue&type=template&id=39cbc2d8&scoped=true&"
import script from "./Reservesub.vue?vue&type=script&lang=js&"
export * from "./Reservesub.vue?vue&type=script&lang=js&"
import style0 from "./Reservesub.vue?vue&type=style&index=0&id=39cbc2d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cbc2d8",
  null
  
)

export default component.exports